import React, { useState, useEffect } from 'react';
import Swal from 'sweetalert2'

import * as Auth from "../../../Login/Auth"
import { SingleInput, SingleRedio, SingleText } from '../../Res/BaseInput';
import { CancelSubmitButton, Space } from '../../Res/BaseButton';
import { ContentBox } from '../../Content/ContentBox';
import { SystemPromptInput } from '../../Res/SystemPrompt';
import { api_getModuleDetail, api_addModule, api_getMoudleList } from '../../../../api/apiModule';
import { RespModuleItem, ReqModule, ReqModuleItem } from '../../../../item/ItemModule';
import { ReqModulePermissionItem } from '../../../../item/ItemModulePermission';
import { api_setModulePermission } from '../../../../api/apiModulePermissiony';


export function ModulePermissionEdit({ id, setIsLoading }) {
  const [applyId, setApplyId] = useState("")
  const [nickName, setNickName] = useState("")
  const [mobile, setMobile] = useState("")
  const [items, setItems] = useState([])
  const [modulePermissionItems, setModulePermissionItems] = useState([])

  const [isLoad, setIsLoad] = useState(false)

  useEffect(() => {
    var modulePermission = Auth.getval2Token('modulePermission', id)
    console.log(modulePermission)
    // console.log(module.moduleId)
    if (modulePermission !== undefined && modulePermission.applyId !== undefined) {
      setApplyId(modulePermission.applyId)
      setNickName(modulePermission.nickName)
      setMobile(modulePermission.mobile)
      if(modulePermission.items.length > 0){
        setItems(modulePermission.items)
      }else{
        getDetial("")
      }
    }else{
      getDetial("")
    }
  }, [])

  // useEffect(() => {
  //   if (moduleId !== undefined && moduleId !== "") {
  //     getDetial(moduleId)
  //   }
  // }, [moduleId])

  useEffect(()=>{
    // console.log(modulePages)
    if(isLoad)
    return
    if(items.length > 0 && modulePermissionItems.length === 0){
      getDetial("")
    }
  },[items])

  function checkPageInit(ps){
    var todo = false;
    var mps = JSON.parse(JSON.stringify(items)) 
    if(ps !== undefined && mps.length >0){
      todo = true
    }
    // console.log(mps)
    // console.log(ps)

    if(todo){
      // console.log(ps)
      mps.forEach(item=>{
        // console.log(item)
        var filterEmpty = ps.filter((module) => {
          return module.moduleId !== item.moduleId;
        });
        ps = filterEmpty
        // console.log(filterEmpty)
      })
    }
    setModulePermissionItems(ps)
  }

  function getDetial(moduleId) {
    setIsLoading(true)
    api_getMoudleList({
      success: (jsonData) => {
        // console.log(jsonData)
        // if (jsonData.detail !== null) {
        //   var mRespModuleItem = new RespModuleItem({})
        //   mRespModuleItem.fromJson(jsonData.detail)

        //   setModuleName(mRespModuleItem.moduleName)
        //   setModulePages(mRespModuleItem.items)
        // }

        checkPageInit(jsonData.list)
        // setPages(jsonData.pages)
        setIsLoad(true)
        setIsLoading(false)
      },
      failure: (err) => {
        setIsLoading(false)
      }
    })
  }

  function toCancel() {
    window.history.back();
  }

  function toEdit() {
    var list = []
    items.forEach(item=>{
      list.push(item.moduleId)
    })
    var mReqModulePermissionItem = new ReqModulePermissionItem({
      applyId,
      items:list
    })
    console.log(mReqModulePermissionItem)
    api_setModulePermission({
      mReqModulePermissionItem,
      success: (jsonData) => {
        Swal.fire({
          type: 'success',
          title: '提醒',
          text: '編輯成功',
        }).then(function () {
          //window.history.replace("/ManagerList");
        })
      },
      failure: (err) => {
        Swal.fire({
          type: 'error',
          title: '提醒',
          text: err.message,
        })
      }
    })
  }


  function choose(val) {
    // console.log('choose')
    var filterEmpty = modulePermissionItems.filter((item) => {
      //console.log(page)
      return item.moduleId === val;
    });
    var list = items.concat(filterEmpty[0])
    //console.log(list)
    filterEmpty = modulePermissionItems.filter((item) => {
      //console.log(page)
      return item.moduleId !== val;
    });
    //console.log(filterEmpty)

    setModulePermissionItems(filterEmpty)
    setItems(list)
  }

  function unChoose(val) {
    var filterEmpty = items.filter((item) => {
      return item.moduleId === val;
    });
    // console.log(filterEmpty)
    // console.log(modulePermissionItems)
    var list = modulePermissionItems.concat(filterEmpty[0])
    // console.log(list)
    filterEmpty = items.filter((item) => {
      //console.log(page)
      return item.moduleId !== val;
    });
    // console.log(filterEmpty)

    setModulePermissionItems(list)
    setItems(filterEmpty)
  }

  var title = <>模組授權</>
  var content =
    <>
      <div className="row">
        <div className="col-md-12">
          <SingleText title={"名稱"} val={nickName} size={4} />

        </div>
      </div>
      <div className="hr-line-dashed"></div>
      <div className="row">
        <div className="col-md-12">
          <div className="col-md-6">
            <p>擁有頁面</p>
            <select className="form-control" multiple="multiple" size="10">
              {
                items.map(item => (
                  <option key={item.moduleId} value={item.moduleId} onClick={e => unChoose(e.target.value)}>{item.moduleName} </option>
                ))
              }
            </select>
          </div>
          <div className="col-md-0">
          </div>
          <div className="col-md-6">
            <p>可選頁面</p>
            <select className="form-control" multiple="multiple" size="10">
              {
                modulePermissionItems.map(item => (
                  <option key={item.moduleId} value={item.moduleId} onClick={e => choose(e.target.value)}>{item.moduleName}</option>
                ))
              }
            </select>
          </div>
        </div>
      </div>
    </>

  var footer =
    <div className="row">
      <div className="col-sm-3 col-sm-offset-9">
        <CancelSubmitButton cancelAction={toCancel} submitName={"儲存"} submitAction={toEdit} isRight={true} />
      </div>
    </div>

  return (
    <>
      <ContentBox title={title} content={content} footer={footer} hasDrawer={true} />
      <SystemPromptInput />
    </>
  )
}